import { h } from 'preact';
import styled from 'styled-components';
import DeferButton from './DeferButton';
import ImageSection from './ImageSection';
import ContentSection from './ContentSection';
import ButtonsSection from './ButtonsSection';
import FooterSection from './FooterSection';
import { PROVISIONS } from '../../common/constants';
import { useState, useEffect } from 'preact/hooks';
import { convertPxToRem } from '@mdigital/common/dist/utils/html';

const StyledInvitationMainDiv = styled.div`
  background-color: ${props => props.backgroundColor};
  width: 100%;
  height: 100%;
  display: block;
`;

const StyledInvitationContentDiv = styled.div`
  visibility: ${props => props.visibility};
  ${props => props.isInviteReflow ? `
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: space-between;
    background-color: ${props.backgroundColor};
    min-height: ${props.vertical}px;
    height: ${props.visibility === 'hidden' ? `${props.vertical}px` : 'unset'};
  ` : `
    overflow-y: auto;
    height: ${props.visibility === 'hidden' ? `${props.vertical}px` : `${props.vertical - 60}px`};
  `}
`;

export default function (props) {
  const [invitationContent,setInvitationContent] = useState(props.application.inviteData?.desktopDesign?.invitationContentText);
  const isRtl = props.application?.inviteData?.isRtl;
  const isWithInviteReflow = props.application.provisions[PROVISIONS.ENABLE_INVITE_REFLOW];

  useEffect(() => {
    isWithInviteReflow && setInvitationContent(convertPxToRem(props.application.inviteData?.desktopDesign?.invitationContentText));
  }, [isWithInviteReflow]);

  const renderFooterSection = (props) => {
    return (
      <FooterSection
        provisions={props.application.provisions}
        isWCAG={props.application.isWCAG}
        toolTipText={props.helpTooltipText}
        globalResourcesUrl={props.application.globalResourcesUrl}
        isDirectionRtl={isRtl}
        poweredByTranslation={props.poweredByForScreenReader}
        isInviteReflow={isWithInviteReflow}
        horizontal={props.application?.invitationJson?.horizontal || props.horizontal}
        poweredByNewTabTranslation={props.poweredByNewTabForScreenReader}
        visibility={props.isLoadingCustomCss || props.isLoadingLogo ? 'hidden' : 'visible'}
      />
    )
  };

  return (
    <StyledInvitationMainDiv className="invitationDesignMain"
      isInviteReflow={isWithInviteReflow}
      backgroundColor={
        props.application.inviteData?.desktopDesign?.invitationBackgroundColor
      }>
      <StyledInvitationContentDiv
        backgroundColor={props.application.inviteData?.desktopDesign?.invitationBackgroundColor}
        className="kpl-invitation-content"
        vertical={props.application?.invitationJson?.vertical || props.vertical}
        visibility={props.isLoadingCustomCss || props.isLoadingLogo ? 'hidden' : 'visible'}
        isInviteReflow={isWithInviteReflow}
      >
        <DeferButton
          onClick={props.onDeferButtonClicked}
          isWCAG={props.application.isWCAG}
          closeModalButton={props.closeModalButton}
          isDirectionRtl={isRtl}
          visibility={props.isLoadingCustomCss || props.isLoadingLogo ? 'hidden' : 'visible'}
          isInviteReflow={isWithInviteReflow}
        />
        <ImageSection
          imageSrc={props.logoUrl}
          imageAlt={props.invitationLogoLabel}
          isInviteReflow={isWithInviteReflow}
          vertical={props.application?.invitationJson?.vertical || props.vertical}
        />
        <ContentSection
          content={invitationContent}
          isWCAG={props.application.isWCAG}
          isInviteReflow={isWithInviteReflow}
        />
        <ButtonsSection
          isWCAG={props.application.isWCAG}
          provideButtonText={props.provideButtonText}
          provideButtonColor={props.invitationProvideButtonColor}
          provideButtonTextColor={props.invitationProvideButtonTextColor}
          onProvideFeedbackClicked={props.onProvideFeedbackClicked}
          declineButtonText={props.declineButtonText}
          declineButtonColor={props.invitationDeclineButtonColor}
          declineButtonTextColor={props.invitationDeclineButtonTextColor}
          onDeclineButtonClicked={props.onDeclineButtonClicked}
          isDirectionRtl={isRtl}
          isInviteReflow={isWithInviteReflow}
        />
        {isWithInviteReflow && renderFooterSection(props)}
      </StyledInvitationContentDiv>
      {!isWithInviteReflow && renderFooterSection(props)}
    </StyledInvitationMainDiv>
  );
}
